import {ActionTree} from 'vuex';
import {AppState} from '@/store/app-state';
import {StoreMutation} from '@/store/mutations';
import {AuthApi} from '@/api/auth-api';

export enum StoreAction {
  LOGIN = 'login',
  LOGOUT = 'logout',
  GET_CURRENT_USER = 'getCurrentUser',
  CLEAR_STATE = 'clearState',
}

export const actions: ActionTree<AppState, AppState> = {

  /**
   * Вход в приложение
   */
  login({commit}, payload) {
    return AuthApi.login(payload)
      .then(({data}) => commit(StoreMutation.SET_USER, data));
  },

  /**
   * Выход из приложения
   */
  logout({commit}) {
    return AuthApi.logout()
      .then(() => commit(StoreMutation.CLEAR_STATE));
  },

  /**
   * Получение текущего пользователя
   */
  getCurrentUser({commit}, payload) {
    return AuthApi.getCurrentUser()
      .then(({data}) => {
        commit(StoreMutation.SET_USER, data);
      });
  },

  /**
   * Выход из приложения
   */
  clearState({commit}) {
    commit(StoreMutation.CLEAR_STATE);
  },
};
